import Appsignal from "@appsignal/javascript";

const appsignal = new Appsignal({
  key: process.env.NEXT_PUBLIC_APPSIGNAL_API_KEY,
});

window.addEventListener("error", (event) => {
  appsignal.sendError(event.error, (span) => {
    span.setAction(window.location.href);
  });
});

window.addEventListener("unhandledrejection", (event) => {
  appsignal.sendError(event.reason, (span) => {
    span.setAction(window.location.href);
  });
});
